<template>
	<AppLayout
		:title="event.title"
		:subtitle="enrollment.user.full_name"
		:return-url="route('events.enrollments.show', enrollment.id)"
		:return-label="trans('enrollments.id', {id: enrollment.id})"
	>
		<template #actions>
			<Badge :color="badgeColor" active>{{ trans(`enrollments.purchase-orders.status.${purchaseOrder.status}`) }}</Badge>
		</template>
		<div class="grid grid-cols-1 lg:grid-cols-9 gap-4">
			<div class="lg:col-span-3">
				<EnrollmentPayments
					:event="event"
					:enrollment="enrollment"
					:bank-accounts="bankAccounts"
					:debit-payment-link="debitPaymentLink"
					:credit-payment-link="creditPaymentLink"
				/>
			</div>
			<div class="lg:col-span-6 flex flex-col gap-3">
				<EnrollmentReceipts
					:enrollment="enrollment"
					:purchase-order="purchaseOrder"
					:receipts="receipts"
				/>
			</div>
		</div>
	</AppLayout>
</template>
<script setup lang="ts">
import {route} from 'ziggy-js'
import {trans} from 'laravel-vue-i18n'
import {Color} from '@/Types/Enums/Color'
import {type Event} from '@/Types/Events/Event'
import AppLayout from '@/Layouts/AppLayout.vue'
import Badge from '@/Components/Badges/Badge.vue'
import {type BankAccount} from '@/Types/Events/Payments/BankAccount'
import {type Enrollment} from '@/Types/Events/Enrollments/Enrollment'
import {computed, type ComputedRef, defineProps, ref, type Ref} from 'vue'
import EnrollmentPayments from '@/Components/Enrollments/EnrollmentPayments.vue'
import EnrollmentReceipts from '@/Components/Enrollments/EnrollmentReceipts.vue'
import {type PurchaseOrder} from '@/Types/Events/Enrollments/PurchaseOrders/PurchaseOrder'
import {type PaymentReceipt} from '@/Types/Events/Enrollments/PurchaseOrders/PaymentReceipt'
import {getPurchaseOrderColorByStatus} from '@/Helpers/Events/Enrollments/PurchaseOrders/status'

const props = defineProps<{
	event:Event,
	enrollment:Enrollment,
	purchaseOrder:PurchaseOrder,
	debitPaymentLink:string|null,
	creditPaymentLink:string|null,
	receipts:Array<PaymentReceipt>,
	bankAccounts:Array<BankAccount>,
}>()

const event:Ref<Event> = ref(props.event)
const enrollment:Ref<Enrollment> = ref(props.enrollment)
const receipts:Ref<Array<PaymentReceipt>> = ref(props.receipts)
const purchaseOrder:Ref<PurchaseOrder> = ref(props.purchaseOrder)
const bankAccounts:Ref<Array<BankAccount>> = ref(props.bankAccounts)
const debitPaymentLink:Ref<string|null> = ref(props.debitPaymentLink)
const creditPaymentLink:Ref<string|null> = ref(props.creditPaymentLink)

const badgeColor:ComputedRef<Color> = computed(():Color => getPurchaseOrderColorByStatus(purchaseOrder.value.status))
</script>